import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import 'react-toastify/dist/ReactToastify.css';
import Inputs from '../Common/Inputs';
import Output from '../Common/Output';
import { convertJsonToXml } from '../Conversion/JsonXmlConvertor';
import RandomContent from '../Components/RandomContent';
import ConversionActions from '../Common/ConversionActions';
import { GetRandomBlogPost, GetPageContentBySlug } from '../services/apiservice';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { jsonToXmlConverterFAQ } from '../Seo/faqSchemas';

const JsonToXml = () => {
    const [inputData, setInputData] = useState('');
    const [outputData, setOutputData] = useState('');
    const [isError, setIsError] = useState(false);
    const [fontSize, setFontSize] = useState(14);
    const [inputLnCol, setInputLnCol] = useState({ line: 1, column: 1 });
    const [outputLnCol, setOutputLnCol] = useState({ line: 1, column: 1 });
    const [tabSpace, setTabSpace] = useState(2);
    const [randomPost, setRandomPost] = useState('');
    const [loadingPost, setLoadingPost] = useState(true);
    const [pageContent, setPageContent] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const paramlink = location.pathname.split('/').filter(Boolean).pop();
    const handleBlogClick = () => navigate('/blog/:paramlink');

    const handleConversion = () => {
        const { convertedData, isError } = convertJsonToXml(inputData);
        setOutputData(convertedData);
        setIsError(isError);
    };

    useEffect(() => {
        setInputData('');
        setOutputData('');
        setIsError(false);
        fetchRandomPost();
        fetchPageContent();
    }, []);

    const fetchRandomPost = async () => {
        setLoadingPost(true);
        try {
            const randomPostData = await GetRandomBlogPost();
            const jsonPostList = JSON.parse(randomPostData);
            setRandomPost(jsonPostList);
            setLoadingPost(false);
        } catch (error) {
            setLoadingPost(false);
            console.error('Error fetching the data:', error);
        }
    };

    const fetchPageContent = async () => {
        try {
            const response = await GetPageContentBySlug(paramlink);
            const parsed = JSON.parse(response);
            setPageContent(parsed);
        } catch (error) {
            console.error('Error fetching page content:', error);
        }
    };

    return (
        <><div>
            <Header />

            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(jsonToXmlConverterFAQ)}
                </script>
            </Helmet>

            <RandomContent />

            <div className="blog-area">
                <div className="container-block-fluid">
                    <div className="row justify-content-center">
                        <div className="full-col col-lg-12 col-md-12">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="2800">
                                <div className="details">
                                    <h4><a href="#">{pageContent?.section1header}</a></h4>
                                    <div dangerouslySetInnerHTML={{ __html: pageContent?.section1text || '<p>Looking for a Free JSON to XML Conversion Online Tool? Data Beautifier makes it simple and efficient! Our Best JSON to XML Converter Online Tool is designed to transform JSON data into XML format seamlessly. With our Simple JSON to XML Converter Tool, you can handle conversions in just a few clicks—no technical expertise required. Whether you’re a developer or a data enthusiast, our Easy JSON to XML Converter Tool ensures accuracy and speed, saving you valuable time. Accessible anytime, Data Beautifier provides reliable results for free. Simplify your data conversion needs with us today!</p>' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="blog-area pb-20">
                <div className="container-block-fluid">
                    <div className="row justify-content-center">
                        <div className="full-col col-lg-5 col-md-5">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="2800">
                                <div className="thumb">
                                    <Inputs
                                        value={inputData}
                                        setValue={(val) => {
                                            setInputData(val);
                                            setIsError(false); // Reset error on change
                                        }}
                                        fontSize={fontSize}
                                        setFontSize={setFontSize}
                                        isError={isError}
                                        lineCol={inputLnCol}
                                        setLineCol={setInputLnCol}
                                        readOnly={false}
                                        idPrefix="input" />
                                </div>
                            </div>
                        </div>

                        <ConversionActions
                            tabSpace={tabSpace}
                            setTabSpace={setTabSpace}
                            handleConversion={handleConversion}
                            outputData={outputData}
                            randomPost={randomPost}
                            loadingPost={loadingPost}
                            handleBlogClick={handleBlogClick}
                            isError={isError}
                            buttonLabel="Minify JS"
                            iconClass="ri-exchange-line"
                        />

                        <div className="full-col col-lg-5 col-md-5">
                            <div className="single-blog-inner" data-aos="fade-up"
                                data-aos-duration="1200">
                                <div className="thumb">
                                    <Output
                                        value={outputData}
                                        setValue={setOutputData}
                                        lineCol={outputLnCol}
                                        setLineCol={setOutputLnCol}
                                        fontSize={fontSize}
                                        setFontSize={setFontSize}
                                        isError={isError}
                                        idPrefix="output" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {pageContent?.section2text && (
                <div className="blog-area">
                    <div className="container-block-fluid">
                        <div className="row justify-content-center">
                            <div className="full-col col-lg-12 col-md-12">
                                <div className="single-blog-inner" data-aos="fade-up" data-aos-duration="2800">
                                    <div className="details">
                                        <div dangerouslySetInnerHTML={{ __html: pageContent.section2text }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Section 3 Below Boxes */}
            {pageContent?.section3text &&
                pageContent.section3text.trim() !== "" && (
                    <div className="blog-area">
                        <div className="container-block-fluid">
                            <div className="row justify-content-center">
                                <div className="full-col col-lg-12 col-md-12">
                                    <div
                                        className="single-blog-inner"
                                        data-aos="fade-up"
                                        data-aos-duration="2800"
                                    >
                                        <div className="details">
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: pageContent.section3text,
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

        </div>

            <Footer />
        </>
    );
};

export default JsonToXml;
